import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import React, { useContext } from 'react';

const MasterPhoneField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = restaurantForFullInfo?.masterPhoneNumber
		? restaurantForFullInfo?.masterPhoneNumber?.replace(/(\+7)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')
		: restaurantForFullInfo?.masterPhoneNumber;

	return <FullInfoField label="masterPhoneNumberLabel" value={inputValue} />;
};

export default MasterPhoneField;
